module.exports = __webpack_public_path__ + "static/celebrate-db13ab5bdb4dff215ba79055c9e60e77.svg";